import { Flex, Image, Loader, Text } from '@mantine/core'
import React from 'react'
import Logo from 'assets/logo.png'
const Fallback = () => {
  return (
   <Flex direction={"column"} justify={"center"} align={"center"} h={"100vh"} w={"100vw"} gap={"2rem"}>
    <Image src={Logo} alt='logo image' width={250} height={150} fit='contain'/>
    <Text>Sit tight, meetings compiling!</Text>
    <Loader variant='dots' size={"lg"}/>
   </Flex>
  )
}

export default Fallback